export enum NumberOfMonths {
    LastThreeMonths = 3,
    LastSixMonths = 6
}